import { Component, input } from '@angular/core';

@Component({
  selector: 'app-physician-card',
  templateUrl: './physician-card.component.html',
  styleUrls: ['./physician-card.component.scss'],
  host: {
    class: 'flex items-center justify-between rounded-lg',
  },
})
export class PhysicianCardComponent {
  name = input<string>('');
  address = input<string>('');
  score = input<number>(0);
  distance = input<number>(0);
  accredited = input<boolean>(false);
}
